import React from 'react';
import cn from 'classnames';

import { Typography } from 'components/shared/Typography';

import { getTranslation } from 'helpers/getTranslation';

import styles from './LessonLocaleTabs.module.scss';

const LessonLocaleTabs = ({
  activeLocale,
  availableLocales,
  localesWithContent,
  onLocaleChange,
}: {
  activeLocale: string;
  availableLocales: readonly string[];
  localesWithContent: string[];
  onLocaleChange: (locale: string) => void;
}) => (
  <div className={styles.root}>
    <div className={styles.tabs} role="tablist" aria-label="Lesson language">
      {availableLocales.map((locale) => {
        const hasContent = localesWithContent.includes(locale);
        const isMissingLocalization = !localesWithContent.includes(locale);

        return (
          <button
            key={locale}
            type="button"
            className={cn(styles.tab, {
              [styles.tabActive]: activeLocale === locale,
            })}
            onClick={() => onLocaleChange(locale)}
          >
            <Typography
              className={styles.label}
              variant="body2"
              weight="medium"
              mode="compact"
            >
              {getTranslation(`lesson_locale_tabs.${locale}`)}
            </Typography>
            {hasContent && (
              <span
                className={cn(styles.indicator, styles.indicatorSuccess)}
                aria-hidden
              />
            )}
            {isMissingLocalization && (
              <span
                className={cn(styles.indicator, styles.indicatorMissing)}
                aria-hidden
              />
            )}
          </button>
        );
      })}
    </div>
  </div>
);

export default React.memo(LessonLocaleTabs) as any;
